<template>
  <div class="zhezhao" v-if="showSignUp">
    <div class="demo-container tankuang">
      <div class="header">
        <div class="header-right" @click="hidder()">x</div>
      </div>

      <div class="demo-left" style="overflow-x: hidden">
        <div class="step-box animated">
          <div class="my-title-box" style="height: 50px; text-align: center">
            <div class="my-title">报名登记表</div>
            <div class="my-subtitle"></div>
          </div>

          <table class="table" cellspacing="0" cellpadding="0" border="0">
            <!-- 第一行：姓名、性别、出生年月、年龄、照片 -->
            <tr>
              <td style="width: 60px" class="tdcenter">
                <font style="color: red">*</font>姓名
              </td>
              <td style="width: 120px">
                <input type="text" v-model="signupInfo.name" />
              </td>
              <td style="width: 60px" class="tdcenter">
                <font style="color: red">*</font>工号
              </td>
              <td style="width: 120px">
                <input type="text" v-model="signupInfo.code" />
              </td>
              <td style="width: 60px" class="tdcenter">
                <font style="color: red">*</font>性别
              </td>
              <td style="width: 100px">
                <select v-model="signupInfo.gender">
                  <option disabled hidden value=""></option>
                  <option :value="1">男</option>
                  <option :value="2">女</option>
                </select>
              </td>

              <td rowspan="4" style="width: 160px" class="tdcenter">
                <!-- 彩色免冠照片上传区域 -->
                <div class="avatar-uploader upload_table">
                  <img :src="signupInfo.headUrl" class="avatar" />
                </div>
              </td>
            </tr>
            <!-- 第二行：民族、籍贯、出生地 -->
            <tr>
              <td style="width: 100px" class="tdcenter">
                <font style="color: red">*</font>出生年月
              </td>
              <td style="width: 180px">
                <el-date-picker
                  style="width: 160px !important"
                  v-model="signupInfo.birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择年月"
                ></el-date-picker>
                <!-- <input style="width:50px;margin-left:5px" type="number" v-model="signupInfo.age" placeholder="岁"/> -->
              </td>
              <td class="tdcenter">  <font style="color: red">*</font>民族</td>
              <td>
                <select id="nation" name="nation" v-model="signupInfo.nation">
                  <option selected disabled hidden value=""></option>
                  <option
                    v-for="(item, index) in nations"
                    :key="index"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </td>
              <td class="tdcenter">联系电话</td>
              <td>
                <input type="text" v-model="signupInfo.telephone" />
              </td>
            </tr>
            <!-- 第三行：入党时间、参加工作、健康状况 -->
            <tr>
              <td style="width: 130px !important" class="tdcenter">
                <font style="color: red">*</font>
                政治<br />面貌
              </td>
              <td>
                <select
                  id="political"
                  name="political"
                  v-model="signupInfo.political"
                >
                  <option selected disabled hidden value=""></option>
                  <option value="群众">群众</option>
                  <option value="共青团员">共青团员</option>
                  <option value="预备党员">预备党员</option>
                  <option value="中共党员">中共党员</option>
                  <option value="其他">其他</option>
                </select>
              </td>
              <td class="tdcenter">
                <font style="color: red">*</font>参加工作时间
              </td>
              <td>
                <el-date-picker
                  style="width: 160px !important"
                  v-model="signupInfo.jobTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择年月"
                ></el-date-picker>
              </td>
              <td class="tdcenter">
                <font style="color: red">*</font>健康状况
              </td>
              <td>
                <input
                  type="text"
                  v-model="signupInfo.health"
                  placeholder="良好/一般等"
                />
              </td>
            </tr>
            <tr>
              <td class="tdcenter">职业技能等级</td>
              <td colspan="2">
                <input
                  type="text"
                  v-model="signupInfo.specialty"
                  placeholder="例：汽车维修工三级"
                />
              </td>
              <td class="tdcenter"> <font style="color: red">*</font>身份证号</td>
              <td colspan="2">
                <input type="text" v-model="signupInfo.idCard" />
              </td>
            </tr>
            <!-- 第四行：专业技术职务、熟悉专业及专长 -->
            <tr>
              <td class="tdcenter"><font style="color: red">*</font>单位</td>
              <td colspan="6">
                <input
                  type="text"
                  v-model="signupInfo.groupDept"
                  placeholder="XX服务站XX车间"
                />
              </td>
            </tr>
            <tr>
              <td class="tdcenter"><font style="color: red">*</font>报考工种</td>
              <td colspan="6">
                <!-- <input type="text" v-model="signupInfo.techPost" /> -->
                <el-radio-group v-model="signupInfo.techPost">
                  <el-radio label="机电维修工（机电一体项目）"
                    >机电维修工（机电一体项目）</el-radio
                  >
                  <el-radio label="钣金工（钣金项目）"
                    >钣金工（钣金项目）</el-radio
                  >
                  <el-radio label="喷漆工（喷漆项目）"
                    >喷漆工（喷漆项目）</el-radio
                  >
                  <el-radio label="轮胎工（轮胎项目）"
                    >轮胎工（轮胎项目）</el-radio
                  >
                </el-radio-group>
              </td>
            </tr>

            <!-- 工作简历 -->
            <tr>
              <td class="tdcenter">工作经历</td>
              <td colspan="6">
                <textarea rows="3" v-model="signupInfo.jobResume"></textarea>
              </td>
            </tr>

            <!-- 声明 -->
            <tr>
              <td class="tdcenter"><font style="color: red">*</font>报名承诺书</td>
              <td colspan="6">
                <el-checkbox v-model="signupInfo.agree">
                  本人承诺，所填报的上述信息均是真实、准确的，不存在任何虚假陈述和遗漏，否则愿承担由此引起的一切责任。
                </el-checkbox>
              </td>
            </tr>
          </table>
          <div
            class="mybtns"
            id="step2BtnTwo"
            style="position: unset; margin-top: 15px; text-align: center"
          >
            <button
              v-if="signupInfo.status == 0"
              class="step3 default-btn next-btn"
              @click="goSignup('zancun')"
            >
              暂存
            </button>
            <button
              v-if="signupInfo.status == 0 || signupInfo.status == 3"
              class="step3 default-btn next-btn"
              @click="goSignup('tijiao')"
            >
              提交
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/request";
export default {
  name: "SignUp",
  props: {
    recruitId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uploadImgUrl: request.uploadFile,
      headers: {
        Authorization: this.$cookies.get(this.$commons.User.Authentication),
      },
      fileType: ["png", "jpg", "jpeg"],
      photoList: [], // 照片上传列表

      showSignUp: false,
      userInfo: {},

      signupInfo: {
        status: 0,
        // 新增Word登记表字段
        gender: "",
        nation: "",
        nativePlace: "",
        birthPlace: "",
        partyTime: "",
        age: "",
        techPost: "",
        specialSkill: "",
        // 全日制学历
        fullEduLevel: "",
        fullDegree: "",
        fullSchoolMajor: "",
        // 在职学历
        partEduLevel: "",
        partDegree: "",
        partSchoolMajor: "",
        nowPost: "",
        headUrl: "", // 照片地址
        // 原有字段保留
        name: "",
        birthday: "",
        jobTime: "",
        political: "",
        telephone: "",
        idCard: "",
        email: "",
        educationAndMajor: "",
        practiceAndTime: "",
        titleAndTime: "",
        health: "",
        postAndTime: "",
        choosePost: "",
        groupDept: "",
        branchOffice: "",
        subOffice: "",
        jobResume: "",
        personalAchieve: "",
        agree: false,
        agreeStatement: 0,
      },
      signupReadOnly: false,

      total: 0,
      pageNum: 1,
      pageSize: 10,
      post: {
        noticeId: "",
      },
      recruitPostList: [],
      recruitNoticeInfo: {},
      noticeInfo: {},
      postList: [],

      nations: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],
    };
  },
  watch: {},
  mounted() {
    let _this = this;
    _this.getNoticeInfo();
    _this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      let _this = this;
      _this.$api.employee
        .getUserInfo()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            console.log("_this.signupInfo.", _this.signupInfo);
            if (
              !_this.signupInfo.id ||
              _this.signupInfo.status == 0 ||
              _this.signupInfo.status == 3
            ) {
              _this.signupInfo.telephone = res.data.telephone || "";

              _this.signupInfo.email = res.data.email || "";
              _this.signupInfo.idCard = res.data.cardNum || "";
              _this.signupInfo.headUrl = res.data.headUrl || "";
              _this.signupInfo.headUrl = res.data.headUrl || "";
              _this.signupInfo.name = res.data.name;
              _this.signupInfo.gender = res.data.gender;
              _this.signupInfo.birthday = res.data.birthday;
              console.log("_this.signupInfo.", _this.signupInfo);

              _this.$forceUpdate();
            }
          } else {
            _this.$layer.success(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getNoticeInfo() {
      let _this = this;
      let parmas = {
        id: _this.recruitId,
      };
      _this.$api.choosePostRecruitNotice
        .getChoosePostInfoById(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.noticeInfo = res.data;
            // _this.postList = [];
            // if (_this.noticeInfo.choosePost) {
            //   let choosePostArr = _this.noticeInfo.choosePost.split(",");
            //   for (let i = 0; i < choosePostArr.length; i++) {
            //     _this.postList.push({
            //       name: choosePostArr[i],
            //       yes: false,
            //       no: false,
            //     });
            //   }
            // }
          }
        })
        .catch(() => {});
    },
    getNoticeInfoById(id) {
      let _this = this;
      let parmas = { id: id };
      _this.$api.choosePostRecruitNotice
        .getChoosePostInfoById(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.noticeInfo = res.data;
          }
        })
        .catch(() => {});
    },
    hidder() {
      let _this = this;
      if (!_this.signupInfo.status) {
        _this.$layer.confirm(
          "该报名尚未提交,是否关闭此窗口?",
          { btn: ["确定", "取消"] },
          function (index) {
            _this.showSignUp = false;
            _this.signupInfo = { status: 0 };
            _this.$layer.close(index);
          },
          function (index) {
            _this.$layer.close(index);
          }
        );
      } else {
        _this.showSignUp = false;
        _this.signupInfo = {};
      }
      _this.$emit("getMySign");
    },
    getSignUpById(id) {
      let _this = this;
      let params = {
        id: id,
      };
      _this.$api.choosePostRecruitNotice
        .getById(params)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            if (res.data) {
              _this.signupInfo = res.data;
              if (_this.signupInfo.choosePost) {
                _this.postList = JSON.parse(_this.signupInfo.choosePost);
              }
              if (_this.signupInfo.agreeStatement == 1) {
                _this.signupInfo.agree = true;
              } else {
                _this.signupInfo.agree = false;
              }
            }
          } else {
            _this.$layer.alert(res.msg);
          }
          console.log("after ==getPostList");
        })
        .catch(() => {})
        .finally(() => {});
    },

    goSignup(val) {
      let _this = this;
      // 提交时必填校验
      if (val === "tijiao") {
        if (!_this.signupInfo.name) {
          return _this.$layer.alert("请填写姓名!");
        }
        if (!_this.signupInfo.gender) {
          return _this.$layer.alert("请选择性别!");
        }
        if (!_this.signupInfo.code) {
          return _this.$layer.alert("请填写工号!");
        }
        if (!_this.signupInfo.birthday) {
          return _this.$layer.alert("请选择出生年月!");
        }

        if (!_this.signupInfo.nation) {
          return _this.$layer.alert("请选择民族!");
        }
        if (!_this.signupInfo.telephone) {
          return _this.$layer.alert("请填写联系电话!");
        }
        if (!_this.signupInfo.political) {
          return _this.$layer.alert("请选择政治面貌!");
        }

        if (!_this.signupInfo.jobTime) {
          return _this.$layer.alert("请选择参加工作时间!");
        }

        if (!_this.signupInfo.health) {
          return _this.$layer.alert("请填写健康状况!");
        }
        if (!_this.signupInfo.groupDept) {
          return _this.$layer.alert("请填写单位!");
        }

        if (!_this.signupInfo.techPost) {
          return _this.$layer.alert("请选择报考工种!");
        }

        if (!_this.signupInfo.agree) {
          _this.$layer.alert("请阅读并勾选报名承诺书");
          return;
        }
      }
      if (!_this.signupInfo.idCard) {
        return _this.$layer.alert("请填写身份证号码	!");
      }

      _this.signupInfo.agreeStatement = _this.signupInfo.agree ? 1 : 0;

      // 新增/编辑提交
      if (_this.signupInfo.id) {
        _this.signupInfo.status = val === "tijiao" ? 1 : 0;
        _this.$api.choosePostRecruitNotice
          .updateSignInfo(_this.signupInfo)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              _this.$layer.alert(val === "tijiao" ? "提交成功" : "暂存成功");
            } else {
              _this.$layer.alert(res.msg);
            }
          })
          .catch(() => {})
          .finally(() => {});
      } else {
        _this.$layer.load(0, { shade: 0.6 });
        _this.signupInfo.status = val === "tijiao" ? 1 : 0;
        _this.signupInfo.recruitId = _this.recruitId;
        _this.$api.choosePostRecruitNotice
          .addSignInfo(_this.signupInfo)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              _this.signupInfo.id = res.data;
              _this.$layer.alert(
                val === "tijiao" ? "提交成功" : "保存成功",
                () => {
                  _this.$layer.closeAll();
                }
              );
            } else {
              _this.$layer.alert(res.msg);
              _this.$layer.closeAll();
            }
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
  },
};
</script>

<style scoped>
select {
  width: 90%;
  height: 30px;
  background: #fff;
  border: 1px solid #ededed;
  padding: 2px 0 2px 5px;
  border-radius: 4px;
}

.header-right {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background: #909399;
  color: #fff;
  right: 5px;
  top: 5px;
  text-align: center;
  cursor: pointer;
}

.header {
  height: 40px;
}

.tankuang {
  position: relative;
  background: #fff;
  height: 100%;
  border-radius: 5px;
  margin: auto;
}

input.error {
  border: 1px solid red !important;
}

label.error {
  font-size: 12px;
  color: #ea5200;
}

.rowBtn {
  width: 88px !important;
  height: 34px;
  background: none;
  border: 1px #ccc solid;
  color: #333;
  margin-left: 10px;
}

.table {
  width: 100%;
  border-top: 1px #ddd solid;
  border-left: 1px #ddd solid;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 4px;
}

.table tr td {
  border-right: 1px #ddd solid;
  border-bottom: 1px #ddd solid;
  padding: 6px 10px;
  vertical-align: middle;
}

.table input {
  height: 40px;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding-left: 10px;
  width: 100%;
}

.innertable input {
  width: 100px;
}

.table textarea {
  width: 100%;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding: 10px;
  resize: none;
}

.tdcenter {
  text-align: center;
  background: #f7f8fa;
}

.upload_table >>> ::v-deep .el-upload__input {
  display: none !important;
}

.upload_table >>> ::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader >>> .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}
.mybtns button {
  padding: 8px 24px;
  margin: 0 8px;
}

/* 单选按钮样式 */
.radio-group-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
}
.radio-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
}
.radio-item input {
  width: auto !important;
  height: auto !important;
  margin-right: 4px;
}
</style>

<style>
.el-date-editor .el-range__close-icon {
  width: 0px !important;
}
.el-select-dense >>> input {
  height: 35px;
}
.el-select-dense >>> .el-input__icon {
  line-height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/choosePostSign2.vue